/* eslint react/no-unescaped-entities: 0 */
/* eslint react/display-name: 0 */
import React, { Component } from "react";
import ImportInstallationsContent from "./ImportInstallationsContent";
import { ROUTE_COMPRESSORS_IMPORT } from "../../../../routes";

export default class extends Component {
  static propTypes = ImportInstallationsContent.propTypes;

  /**
   * {@inheritdoc}
   */
  render() {
    return (
      <div>
        <p>
          Om uw installaties te importeren, moeten de gegevens worden opgeslagen 
          in ODS- of TSV-formaat en de volgende structuur volgen:
        </p>

        <ul>
          <li>Klant nr. <i>(optioneel) - Als een installatieregel geen klantnummer heeft, wordt de installatie aangemaakt voor het klantaccount waaraan u bent gekoppeld.</i></li>
          <li>Locatie nummer</li>
          <li>Installatienummer.</li>
          <li>Koudemiddel Code</li>
          <li>
            Vloeistof
          </li>
          <li>
            Olie <i>(optioneel)</i>
          </li>
          <li>
            Warmteoverdrachtvloeistof <i>(optioneel)</i>
          </li>
          <li>Nominale belasting</li>
          <li>Huidige belasting</li>
          <li>
            Identificatienummer <i>(optioneel)</i>
          </li>
          <li>Markering</li>
          <li>Datum van ingebruikname</li>
          <li>Datum van de laatste terugkerende inspectie</li>
          <li>
            Indirecte lekdetector <i>(0 = geen detector | 1 = detector aanwezig)</i>
          </li>
        </ul>
        <small>Velden die alleen nodig zijn als er een compressor aan de installatie wordt toegevoegd:</small>
        <ul>
          <li>Compressor: Markering</li>
          <li>Compressor: Identificatienummer <i>(optioneel)</i></li>
          <li>Compressor: Serienummer <i>(optioneel)</i></li>
          <li>Compressor: Type</li>
          <li>Compressor: Klasse</li>
          <li>Compressor: Merk <i>(optioneel)</i></li>
        </ul>

        <p>{this.props.downloadSample}</p>

        <p>
          Om meerdere compressoren in één installatie te importeren, <a href={ROUTE_COMPRESSORS_IMPORT}>klik hier</a>.
        </p>

        <p>
          Na de integratie informeert een samenvatting u over het aantal aangemaakte of bijgewerkte entiteiten en wordt er een anomaliebestand verstrekt met de niet-geïntegreerde regels en de reden(en) voor de afwijzing.
        </p>

        <p>De mogelijke redenen voor anomalieën zijn:</p>

        <ul>
          <li>Afwezigheid van verplichte gegevens</li>
          <li>Vloeistof, olie of warmteoverdrachtvloeistof niet aanwezig</li>
          <li>Waarde verschillend van 1/0</li>
          <li>Ongeldige datum</li>
          <li>Type, klasse of merk van compressor niet aanwezig</li>
        </ul>
      </div>
    );
  }
}
